import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Hls from 'hls.js';
import './VideoPlayer.scss';

import Comments from './Comments';
import { isWebView, post } from '../../../Utilities';

function PlyrHlsVideoPlayer(props) {
  const { match, history, link, heightauto, sectionFileId, clientUserId } = props;

  /* eslint-disable */
  const videoRef = useRef(null);
  const intervalRef = useRef();
  const [source, setSource] = useState('');

  const [videoId, setVideoId] = useState('');

  const updateQuality = (newQuality) => {
    window.hls.levels.forEach((level, levelIndex) => {
      if (level.height == newQuality) {
        window.hls.currentLevel = levelIndex;
      }
    });
  };

  useEffect(() => {
    if (isWebView && typeof window.Android.disableScreenshot !== 'undefined') {
      window.Android.disableScreenshot();
    }
    if (isWebView && typeof window.Android.setScreenOrientation !== 'undefined') {
      window.Android.setScreenOrientation('uncpecified');
    }
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    
    if (history?.location.state && history?.location.state.videoId)
      setVideoId(history.location.state.videoId);

    if (history?.location.state && history?.location.state.videoLink) {
      const newSource = JSON.parse(JSON.stringify(source));
      setSource(newSource);
    }
  }, [history]);

  useEffect(() => {
    function loadScript(url, onLoadCallback) {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;

      if (onLoadCallback) {
        script.onload = onLoadCallback;
      }

      document.body.appendChild(script);
    }

    // Example usage:
    loadScript('https://cdn.plyr.io/3.7.8/plyr.js', function () {
      // The script has been loaded and executed, you can use its functionality here.
      console.log('External script has been loaded!');
      const video = document.getElementById('player');
      const defaultOptions = {};
      if (Hls.isSupported()) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const url = urlParams?.get('url');
        const hls = new Hls();
        if (link) {
          setSource(link);
          hls.attachMedia(video);
          hls?.loadSource(link);
        } else if (history?.location.state && history?.location.state.videoLink) {
          setSource(history?.location.state.videoLink);
          hls.attachMedia(video);
          hls.loadSource(history?.location?.state?.videoLink);
        } else if (url) {
          setSource(url);
          hls.attachMedia(video);
          hls.loadSource(url);
        }
        hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
          const availableQualities = hls.levels.map((l) => l.height);
          defaultOptions.controls =
            document.body.clientWidth < 500
              ? [
                  'play-large', // The large play button in the center
                  'restart', // Restart playback
                  'rewind', // Rewind by the seek time (default 10 seconds)
                  'play', // Play/pause playback
                  'fast-forward', // Fast forward by the seek time (default 10 seconds)
                  'progress', // The progress bar and scrubber for playback and buffering
                  'current-time', // The current time of playback
                  'duration', // The full duration of the media
                  // 'mute', // Toggle mute
                  // 'volume', // Volume control
                  // 'captions', // Toggle captions
                  'settings', // Settings menu
                  // 'pip', // Picture-in-picture (currently Safari only)
                  // 'airplay', // Airplay (currently Safari only)
                  'fullscreen', // Toggle fullscreen
                ]
              : [
                  'play-large', // The large play button in the center
                  'restart', // Restart playback
                  'rewind', // Rewind by the seek time (default 10 seconds)
                  'play', // Play/pause playback
                  'fast-forward', // Fast forward by the seek time (default 10 seconds)
                  'progress', // The progress bar and scrubber for playback and buffering
                  'current-time', // The current time of playback
                  'duration', // The full duration of the media
                  'mute', // Toggle mute
                  'volume', // Volume control
                  // 'captions', // Toggle captions
                  'settings', // Settings menu
                  'pip', // Picture-in-picture (currently Safari only)
                  'airplay', // Airplay (currently Safari only)
                  'fullscreen', // Toggle fullscreen
                ];
          defaultOptions.quality = {
            default: availableQualities[0],
            options: availableQualities,
            forced: true,
            onChange: (e) => updateQuality(e, hls),
          };
          new Plyr(video, defaultOptions);
        });
        hls.attachMedia(video);
        if (window.hls) {
          window.hls.destroy();
        }
        window.hls = hls;
        if (videoRef && videoRef?.current) {
          setTimeout(() => {
            videoRef.current.play(); // Trigger the play function programmatically
          }, 500);
        }
      }
      // Your script-related logic goes here.
    });
  }, [link]);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    const updateProgress = () => {
      if (video && sectionFileId) {
        const duration = Math.max(Math.ceil(video.duration / 30) * 1000, 5000);
        console.log('Video Progress:', video.currentTime);
        const curDur =
          video.duration - video.currentTime > duration / 1000 ? video.currentTime : video.duration;
        console.log(curDur, 'curDur');
        if (curDur > 1) {
          const payload = {
            section_has_file_id: sectionFileId,
            client_user_id: clientUserId,
            total_time: video.duration,
            type: 'file',
            finished_time: curDur,
          };
          console.log(payload);
          post(payload, '/updateCourseContentViewStatus').catch(console.error);
        }
      }
    };

    const startTracking = () => {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(updateProgress, 5000);
      }
    };

    const stopTracking = () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };

    video.addEventListener('play', startTracking);
    video.addEventListener('pause', stopTracking);
    video.addEventListener('ended', stopTracking);

    return () => {
      stopTracking();
      video.removeEventListener('play', startTracking);
      video.removeEventListener('pause', stopTracking);
      video.removeEventListener('ended', stopTracking);
    };
  }, []);

  return (
    <div className='hlsPlayerContainer'>
      <div className=''>
        <video ref={videoRef} className='w-100' id='player' controls></video>
        {history?.location.state && (
          <p className='hlsPlayerVidName text-center mt-3'>
            {history.location.state.fileName || ''}
          </p>
        )}
      </div>
      {/* {videoId && <Comments videoId={videoId} />} */}
    </div>
  );
}

export default PlyrHlsVideoPlayer;

PlyrHlsVideoPlayer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  link: PropTypes.string.isRequired,
  heightauto: PropTypes.bool.isRequired,
};
